import React, {Component} from 'react';
import { readUploadResponse } from '../../utils/uploadResponse';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import Select from 'react-select';
import Modal from 'react-modal';
import 'react-dropdown/style.css';
import ReactToPrint from "react-to-print";
import ProductPrintLabel from './ProductPrintLabel';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import 'react-dropdown/style.css';
import matchSorter from 'match-sorter';
import { CSVLink } from "react-csv";
import './ProductVolumeDetail.css';

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '400px',
    color                 : 'black'
  },
  overlay: {zIndex: 1000}
};

const printModalStyle = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    marginRight           : '-50%',
    transform             : 'translate(-50%, -50%)',
    width                 : '500px',
    color                 : 'black'
  },
  overlay: {zIndex: 1000}
};
class ProductVolumeDetail extends Component {

    constructor(props) {
        super(props);          

        this.state = {
            upc_search: '',              
            cl_id: typeof(localStorage.getItem('headerClientId')) === 'undefined' ? 0 : localStorage.getItem('headerClientId'), 
            userToken: localStorage.getItem('userToken'),
            selectedVolumeFile: null,
            volumeUploadResponse: ''
        };               
        
        this.handleVolumeFileChange = this.handleVolumeFileChange.bind(this);
        this.handleVolumeFileUpload = this.handleVolumeFileUpload.bind(this);
    }

    componentDidMount() {
      Modal.setAppElement('#main');
      
    }
   
    componentDidUpdate(prevProps, prevState) {
     
    }

    handleVolumeFileChange(e) {
        this.setState({ selectedVolumeFile: e.target.files[0] });
    }

    handleVolumeFileUpload(e) {
        e.preventDefault();
        const { selectedVolumeFile, cl_id } = this.state;
        if (!selectedVolumeFile) return;
        const data = new FormData();
        data.append('file', selectedVolumeFile);
        fetch(process.env.REACT_APP_NODE_ROOT_URL + '/upload/vol/' + cl_id, {
            method: 'POST',
            body: data,
            headers: {
                'bwToken': this.state.userToken
            }
        })
        .then(readUploadResponse)
        .then(response => {
            this.setState({ volumeUploadResponse: response.success ? 'Upload successful!' : 'Upload failed.' });
        })
        .catch(error => {
            this.setState({ volumeUploadResponse: 'Upload failed. ' + error.message });
        });
    }

    render(){     
      // Template CSV link (adjust path as needed)
      const templateCsvUrl = process.env.REACT_APP_ROOT_URL + '/files/product-volume-import.csv';
        return (
          <div id="main">
            <div className="container mt-5 product-volume-container">
          <div className="row justify-content-center">
            <div className="col-md-6">
              <div className="card">
                <div className="card-body">
                  <h3 className="card-title mb-4 product-title">Import Product Volumes</h3>
                  <form onSubmit={this.handleVolumeFileUpload}>
                    <div className="form-group mb-3">
                      <label htmlFor="volumeCsvFile" className="form-label">Select CSV File</label>
                      <input
                        type="file"
                        className="form-control"
                        id="volumeCsvFile"
                        accept=".csv"
                        onChange={this.handleVolumeFileChange}
                      />
                    </div>
                    <button type="submit" className="btn btn-primary upload-btn">Upload CSV</button>
                  </form>
                  <div className="mt-3">
                    <a href={templateCsvUrl} target="_blank" rel="noopener noreferrer" className="template-link">
                      Download Product Volume Import Template
                    </a>
                  </div>
                  {this.state.volumeUploadResponse && (
                    <div className="alert mt-3 " style={{color: this.state.volumeUploadResponse.includes('success') ? 'green' : 'red'}}>
                      {this.state.volumeUploadResponse}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>

                )
    }
}
export default ProductVolumeDetail;